<div class="col-lg-12 parent">
  <div class="card-spacing-0">
    <span
      class="d-flex justify-content-between align-items-center m-3 globalborder-btm-header pb-3 mt-1">
      <span class="col-auto">
        <h2 class="mb-0">{{ showProFormalDialogHeading }}</h2>
      </span>

      <span>
        <span class="cross-border" (click)="closeModal()"
          ><i class="pi pi-times"></i
        ></span>
      </span>
    </span>

    <div class="pb-2 col-lg-12 orders-list px-3">
      <div class="gray-bg-rounded mb-3">
        <div class="row pb-2">
          <div class="col-3" *ngIf="reportType === 'depositInvoice'">
            <div class="form-group has-float-label col">
              <label class="form-label">Percentage</label>
              <input
                pInputText
                jniAutoCompleteBlocker
                [(ngModel)]="dialogPercentage"
                type="text"
                jniNumberOnlyWithTwoDecimals
                class="form-control" />
            </div>
          </div>

          <div class="col-3">
            <div class="form-group has-float-label col">
              <label class="form-label">Estimated Freight </label>
              <input
                pInputText
                jniAutoCompleteBlocker
                [(ngModel)]="dialogEstimatedFreight"
                type="text"
                jniNumberOnlyWithTwoDecimals
                class="form-control" />
            </div>
          </div>

          <div class="col-3">
            <div class="form-group has-float-label">
              <label class="form-label">Estimated Tax </label>
              <input
                pInputText
                jniAutoCompleteBlocker
                [(ngModel)]="dialogEstimatedTax"
                type="text"
                jniNumberOnlyWithTwoDecimals
                class="form-control" />
            </div>
          </div>
          <div class="col-3">
            <div
              class="form-check form-switch d-flex align-items-center mt-1 pt-4 gap-2">
              <p-toggleswitch
                jniAutoCompleteBlocker
                type="checkbox"
                [(ngModel)]="dialogIncludeShippingHandling"
                id="flexSwitchCheckDefault4"
                name="flexSwitchCheckDefault4" />

              <label class="form-label">Include shippping & handling? </label>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="gray-bg-rounded">
          <p-table
            #dt
            stripedRows
            [rowHover]="true"
            [rows]="20"
            [value]="salesOrderLine"
            [(selection)]="selectedSaleOrderLine"
            [size]="'small'"
            [showCurrentPageReport]="true"
            [rowsPerPageOptions]="[10, 25, 50]"
            [paginator]="false"
            [filterDelay]="0"
            [scrollable]="true"
            scrollHeight="calc(100vh - 390px)"
            dataKey="salesOrderLine.id"
            editMode="row"
            selectionMode="multiple"
            styleClass="table-listing">
            <ng-template pTemplate="header">
              <tr class="table-head">
                <th class="col-center" style="width: 3rem">
                  <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th class="number">#</th>
                <th class="vendor-sku">Vendor Sku</th>
                <th class="vendor-sku">Category</th>
                <th
                  class="description"
                  [ngClass]="{ trimmedby50char: descriptionCharacterCond }">
                  Description
                </th>
                <th class="unmatched">UnMat</th>
                <th class="quantity">Qty</th>
                <th class="sell">Sell</th>
                <th class="sell-total">Sell Total</th>
                <th class="net">Net</th>
                <th class="net">Net Total</th>
                <th class="net">Net Gp%</th>
                <th class="status">Status</th>
                <th style="width: 100px" class="vendor-name">Vendor Name</th>
                <th class="vendor-name">PO#</th>
                <th class="vendor-name">PO Assign</th>
              </tr>
            </ng-template>
            <ng-template
              pTemplate="body"
              let-salesOrderLine
              let-editing="editing"
              let-ri="rowIndex">
              <ng-container>
                <tr
                  [ngClass]="{
                    odd: !getOddEvenNumber(ri),
                    even: getOddEvenNumber(ri),
                  }"
                  class="p-selectable-row"
                  [pEditableRow]="salesOrderLine"
                  [pSelectableRow]="salesOrderLine">
                  <td class="col-center">
                    <p-tableCheckbox
                      [pSelectableRow]="salesOrderLine"
                      [value]="salesOrderLine"></p-tableCheckbox>
                  </td>
                  <td class="number">
                    {{ salesOrderLine.salesOrderLine.lineNumberD365 }}
                  </td>
                  <td class="vendor-sku">
                    {{ salesOrderLine.salesOrderLine.externalItemNumberD365 }}
                  </td>
                  <td>
                    {{ salesOrderLine.salesOrderLine.itemNumberD365 }}
                  </td>
                  <td
                    class="description text-truncate hoverwdth"
                    [ngClass]="{
                      'trimmeddescription trimmedby50char':
                        descriptionCharacterCond,
                    }"
                    pTooltip="{{
                      salesOrderLine.salesOrderLine.lineDescriptionD365
                    }}"
                    [tooltipOptions]="toolTipOptions">
                    {{
                      descriptionCharacterCount(
                        salesOrderLine.salesOrderLine.lineDescriptionD365
                      )
                    }}
                    {{ salesOrderLine.salesOrderLine.lineDescriptionD365 }}
                  </td>
                  <td class="number unmatched">
                    {{
                      salesOrderLine.salesOrderLine.deliverRemainderD365 !==
                      null
                        ? salesOrderLine.salesOrderLine.deliverRemainderD365
                        : salesOrderLine.salesOrderLine
                            .orderedPurchaseQuantityD365
                    }}
                  </td>
                  <td class="quantity">
                    {{
                      salesOrderLine.salesOrderLine.orderedPurchaseQuantityD365
                    }}
                  </td>
                  <td class="sell">
                    {{
                      salesOrderLine.salesOrderLine.sellD365
                        | currency: foreignCurrency : "symbol" : "0.3-3"
                    }}
                  </td>
                  <td class="sell-total">
                    {{
                      salesOrderLine.salesOrderLine.sellTotalD365
                        | currency: foreignCurrency : "symbol" : "1.2-2"
                    }}
                  </td>
                  <td class="net">
                    {{
                      salesOrderLine.salesOrderLine.purchasePriceD365
                        | currency
                          : salesOrderLine.salesOrderLine.currencyCodeD365
                          : "symbol"
                          : "0.4-4"
                    }}
                  </td>
                  <td class="net" style="text-align: right">
                    {{
                      salesOrderLine?.salesOrderLine?.netTotalD365
                        | currency: "USD" : "symbol" : "1.2-2"
                    }}
                  </td>
                  <td style="white-space: nowrap">
                    {{
                      getNetGpPercentage(
                        salesOrderLine?.salesOrderLine?.netTotalD365 === null
                          ? salesOrderLine?.salesOrderLine?.netTotalD365
                          : salesOrderLine?.salesOrderLine?.netTotalD365,
                        salesOrderLine?.salesOrderLine?.sellTotalD365
                      ) | number: "1.2-2"
                    }}
                    <span
                      *ngIf="
                        salesOrderLine?.salesOrderLine?.sellTotalD365 &&
                        (salesOrderLine?.salesOrderLine?.netTotalD365 ||
                          salesOrderLine?.salesOrderLine?.netTotalD365)
                      ">
                      {{ percentageSign }}
                    </span>
                  </td>
                  <td class="status">
                    {{ salesOrderLine.salesOrderLine.lineStatusD365 }}
                  </td>
                  <td class="vendor-name" style="width: 100px">
                    {{ salesOrderLine.salesOrderLine.vendorNameD365 }}
                  </td>
                  <td>
                    {{ salesOrderLine.salesOrderLine.purchaseOrderD365 }}
                  </td>
                  <td>
                    {{ salesOrderLine.salesOrderLine.vendorPoAssignmentD365 }}
                  </td>
                </tr>
              </ng-container>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="20">No line item found.</td>
              </tr>
            </ng-template>
          </p-table>
          <div class="d-flex p-3 pb-0 justify-content-end">
            <p-button label="Print" (click)="printProFormalDialog()" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <div class="orders-list">
  <div
    class="order-line-sticky-header align-items-center justify-content-between pb-3">
    <div class="align-items-center">
      <div>
        <i class="pi pi-times"></i>
      </div>
      <div class="row mt-3">
        <div class="col-3 mb-4" *ngIf="reportType === 'depositInvoice'">
          <div class="form-group has-float-label mb-4 col mb-4">
            <input pInputText 
              jniAutoCompleteBlocker
              [(ngModel)]="dialogPercentage"
              type="text"
              jniNumberOnlyWithTwoDecimals
              class="form-control" />
            <label class="form-label">Percentage </label>
          </div>
        </div>

        <div class="col-3 mb-4">
          <div class="form-group has-float-label mb-4 col mb-4">
            <input pInputText 
              jniAutoCompleteBlocker
              [(ngModel)]="dialogEstimatedFreight"
              type="text"
              jniNumberOnlyWithTwoDecimals
              class="form-control" />
            <label class="form-label">Estimated Freight </label>
          </div>
        </div>

        <div class="col-3 mb-4">
          <div class="form-group has-float-label mb-4">
            <input pInputText 
              jniAutoCompleteBlocker
              [(ngModel)]="dialogEstimatedTax"
              type="text"
              jniNumberOnlyWithTwoDecimals
              class="form-control" />
            <label class="form-label">Estimated Tax </label>
          </div>
        </div>
        <div class="col-3 mb-4">
          <div class="form-check form-switch d-flex align-items-center m-0">
            <label class="form-label">Include shippping & handling? </label>
            <input pInputText 
              jniAutoCompleteBlocker
              type="checkbox"
              [(ngModel)]="dialogIncludeShippingHandling"
              id="flexSwitchCheckDefault4"
              name="flexSwitchCheckDefault4"
              class="form-check-input me-2 mx-3" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="orders-list">
    <p-table
      #dt
      stripedRows
      [rowHover]="true"
      [rows]="20"
      [value]="salesOrderLine"
      [(selection)]="selectedSaleOrderLine"
      [rowHover]="true"
      [rows]="10"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 25, 50]"
      [paginator]="false"
      [filterDelay]="0"
      dataKey="salesOrderLine.id"
      editMode="row"
      selectionMode="multiple"
      styleClass="table-listing">
      <ng-template pTemplate="header">
        <tr class="table-head">
          <th class="col-center" style="width: 3rem">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th class="number">#</th>
          <th class="vendor-sku">Vendor Sku</th>
          <th class="vendor-sku">Category</th>
          <th
            class="description"
            [ngClass]="{ trimmedby50char: descriptionCharacterCond }">
            Description
          </th>
          <th class="unmatched">UnMat</th>
          <th class="quantity">Qty</th>
          <th class="sell">Sell</th>
          <th class="sell-total">Sell Total</th>
          <th class="net">Net</th>
          <th class="net">Net Total</th>
          <th class="net">Net Gp%</th>
          <th class="status">Status</th>
          <th style="width: 100px" class="vendor-name">Vendor Name</th>
          <th class="vendor-name">PO#</th>
          <th class="vendor-name">PO Assign</th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-salesOrderLine
        let-editing="editing"
        let-ri="rowIndex">
        <ng-container>
          <tr
            [ngClass]="{
              odd: !getOddEvenNumber(ri),
              even: getOddEvenNumber(ri),
            }"
            class="p-selectable-row"
            [pEditableRow]="salesOrderLine"
            [pSelectableRow]="salesOrderLine">
            <td class="col-center">
              <p-tableCheckbox
                [pSelectableRow]="salesOrderLine"
                [value]="salesOrderLine"></p-tableCheckbox>
            </td>
            <td class="number">
              {{ salesOrderLine.salesOrderLine.lineNumberD365 }}
            </td>
            <td class="vendor-sku">
              {{ salesOrderLine.salesOrderLine.externalItemNumberD365 }}
            </td>
            <td>
              {{ salesOrderLine.salesOrderLine.itemNumberD365 }}
            </td>
            <td
              class="description"
              [ngClass]="{
                'trimmeddescription trimmedby50char': descriptionCharacterCond,
              }">
              {{
                descriptionCharacterCount(
                  salesOrderLine.salesOrderLine.lineDescriptionD365
                )
              }}
              {{ salesOrderLine.salesOrderLine.lineDescriptionD365 }}
            </td>
            <td class="number unmatched">
              {{
                salesOrderLine.salesOrderLine.deliverRemainderD365 !== null
                  ? salesOrderLine.salesOrderLine.deliverRemainderD365
                  : salesOrderLine.salesOrderLine.orderedPurchaseQuantityD365
              }}
            </td>
            <td class="quantity">
              {{ salesOrderLine.salesOrderLine.orderedPurchaseQuantityD365 }}
            </td>
            <td class="sell">
              {{
                salesOrderLine.salesOrderLine.sellD365
                  | currency: foreignCurrency : "symbol" : "0.3-3"
              }}
            </td>
            <td class="sell-total">
              {{
                salesOrderLine.salesOrderLine.sellTotalD365
                  | currency: foreignCurrency : "symbol" : "1.2-2"
              }}
            </td>
            <td class="net">
              {{
                salesOrderLine.salesOrderLine.purchasePriceD365
                  | currency
                    : salesOrderLine.salesOrderLine.currencyCodeD365
                    : "symbol"
                    : "0.4-4"
              }}
            </td>
            <td class="net" style="text-align: right">
              {{
                salesOrderLine?.salesOrderLine?.netTotalD365
                  | currency: "USD" : "symbol" : "1.2-2"
              }}
            </td>
            <td style="white-space: nowrap">
              {{
                getNetGpPercentage(
                  salesOrderLine?.salesOrderLine?.netTotalD365 === null
                    ? salesOrderLine?.salesOrderLine?.netTotalD365
                    : salesOrderLine?.salesOrderLine?.netTotalD365,
                  salesOrderLine?.salesOrderLine?.sellTotalD365
                ) | number: "1.2-2"
              }}
              <span
                *ngIf="
                  salesOrderLine?.salesOrderLine?.sellTotalD365 &&
                  (salesOrderLine?.salesOrderLine?.netTotalD365 ||
                    salesOrderLine?.salesOrderLine?.netTotalD365)
                ">
                {{ percentageSign }}
              </span>
            </td>
            <td class="status">
              {{ salesOrderLine.salesOrderLine.lineStatusD365 }}
            </td>
            <td class="vendor-name" style="width: 100px">
              {{ salesOrderLine.salesOrderLine.vendorNameD365 }}
            </td>
            <td>
              {{ salesOrderLine.salesOrderLine.purchaseOrderD365 }}
            </td>
            <td>
              {{ salesOrderLine.salesOrderLine.vendorPoAssignmentD365 }}
            </td>
          </tr>
        </ng-container>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="20">No line item found.</td>
        </tr>
      </ng-template>
    </p-table>

    <div class="d-flex py-3 justify-content-end">
      <button
        (click)="printProFormalDialog()"
        class="btn btn-primary"
        type="submit">
        Print
      </button>
    </div>
  </div> -->

<jni-modal-stacker
  *ngIf="pdfViewerPage"
  [displayModal]="pdfViewerPage"
  (closeEvent)="closeModalPdfViewerPage()"
  class="modal-header-sticky">
  <h1 class="panelHeading mt-5"></h1>
  <div class="panelBody">
    <jni-pdf-viewer-page
      [isModal]="true"
      [base64pdf]="base64Pdf"
      [fileNameToDownload]="fileNameToDownload"
      (closePdfStackerEvent)="closeModalPdfViewerPage()">
    </jni-pdf-viewer-page>
  </div>
</jni-modal-stacker>
